import { canStartWork } from "@veyso/core";
import type { BillingView } from "../api.js";

/**
 * Whether this account may start a project at all.
 *
 * Asked when the new-project screen opens, so the form is never shown to
 * somebody who cannot use it — the refusal used to arrive from the server
 * after a file, a tone, an audience and a purpose had all been chosen.
 *
 * Its own function because of the first branch. A deployment that does not
 * bill has no accounts and nothing to check, and getting that wrong does not
 * produce a wrong price — it locks every self-hosted install out of making
 * projects at all, which is a far worse failure than the one being fixed.
 */
export function canStartProject(view: BillingView): boolean {
  if (!view.billing) return true;

  return canStartWork({
    freeRemaining: view.freeRemaining,
    freeVideoLimit: view.freeVideoLimit,
    balanceUsd: view.balanceUsd,
    freeForever: view.freeForever,
  });
}
